import type { ReactNode, Ref } from 'react';

import styles from '@/components/book/Disclosure.module.css';

interface DisclosureProps {
  summary: ReactNode;
  children: ReactNode;
  ref?: Ref<HTMLDetailsElement>;
  /** `meta` sets the summary in the small sans of a margin part instead of the italic of a list. */
  tone?: 'quiet' | 'meta';
  /** Told when the reader opens or closes it, for a view that draws differently while it is open. */
  onToggle?: (open: boolean) => void;
}

/** The `‹n› more …` fold at the end of a long list, `+` closed and `−` open. */
export function Disclosure({ summary, children, ref, tone = 'quiet', onToggle }: DisclosureProps) {
  return (
    <details ref={ref} className={styles.more} onToggle={onToggle && ((e) => onToggle(e.currentTarget.open))}>
      <summary className={[styles.summary, tone === 'meta' && styles.meta].filter(Boolean).join(' ')}>{summary}</summary>
      {children}
    </details>
  );
}
